import { GeoCullDTO, MediumDTO, PlayerCullDTO, ScheduledCampaignDTO, ScheduledCommercialDTO, TimeCullDTO } from '../api/api';
import { ResourceModel } from '@bryntum/scheduler/scheduler.module.js';

export interface BookingEditorCampaignModel {
  commercialRows?: BookingEditorCommercialRowModel[];
  expanded: boolean;
  assignable: boolean;
  campaign: ScheduledCampaignDTO;
  id: number;
}

export interface BookingEditorCommercialRowModel {
  id: number;
  name: string;
  assignable: boolean;
  timeCull: TimeCullDTO;
  playerCull: PlayerCullDTO;
  geoCull: GeoCullDTO;
}

export interface BookingEditorCommercialModel {
  resourceId: number;
  name?: string;
  startDate: Date;
  endDate: Date;
  commercial?: ScheduledCommercialDTO;
  eventStyle?: string;
  eventColor?: string;
  cls?: string;
  borderColor?: string;
  planning?: boolean;
  loading: boolean;
  previews: MediumDTO[];
}

export interface BookingEditorData {
  bookingEditorCampaigns: BookingEditorCampaignModel[];
  bookingEditorCommercials: BookingEditorCommercialModel[];
}

export class CampaignModel extends ResourceModel {
  static get fields() {
    return [
      // New custom fields:
      { name: 'campaign' },
      { name: 'assignable', type: 'boolean' },
    ];
  }
}
